var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-card',{staticClass:"header-solid h-full",attrs:{"bordered":false,"bodyStyle":{ paddingTop: 0, paddingBottom: 0 }}},[_c('h6',{staticClass:"font-semibold mt-30 mb-10"},[_vm._v("Info")]),_c('a-descriptions',{staticClass:"mb-10",attrs:{"title":"","column":1}},[_c('a-descriptions-item',{attrs:{"label":""}},[_c('p',{staticClass:"mt-5 mb-5 text-muted"},[_vm._v(" Thai ID : "),_c('span',{staticClass:"text-dark"},[_vm._v(" "+_vm._s(_vm.dataContact[0].thai_id_no)+" ")])])]),_c('a-descriptions-item',{attrs:{"label":""}},[_c('p',{staticClass:"mt-0 mb-0 text-muted"},[_vm._v(" Passport : "),_c('span',{staticClass:"text-dark"},[_vm._v(" "+_vm._s(_vm.dataContact[0].passport_no)+" ")])])]),_c('a-descriptions-item',{attrs:{"label":""}},[_c('p',{staticClass:"mt-0 mb-0 text-muted"},[_vm._v(" Birth Date : "),_c('span',{staticClass:"text-dark mr-5"},[_vm._v(" "+_vm._s(_vm.dataContact[0].date_of_birth)+" ")]),_vm._v(" Gender : "),_c('span',{staticClass:"text-dark"},[_vm._v(" "+_vm._s(_vm.dataContact[0].gender)+" ")])])]),_c('a-descriptions-item',{attrs:{"label":""}},[_c('p',{staticClass:"mt-0 mb-0 text-muted"},[_vm._v(" Main Contact : ")]),_c('p',{staticClass:"text-muted mt-5 mb-5 f-12"}),_c('p',{staticClass:"text-muted mt-5 mb-10 f-12"},[_c('ul',[_c('li',[_vm._v("Tel : "+_vm._s(_vm.dataContact[0].main_contact_detail_mobile_number))]),_c('li',[_vm._v("Address : "+_vm._s(_vm.dataContact[0].main_contact_detail_address))]),_c('li',[_vm._v(" Sub District : "+_vm._s(_vm.dataContact[0].main_contact_detail_sub_district)+" ")]),_c('li',[_vm._v(" District : "+_vm._s(_vm.dataContact[0].main_contact_detail_district)+" ")]),_c('li',[_vm._v(" Province : "+_vm._s(_vm.dataContact[0].main_contact_detail_province)+" ")]),_c('li',[_vm._v(" Postal Code : "+_vm._s(_vm.dataContact[0].main_contact_detail_postal_code)+" ")])])])])],1)],1),_c('h6',{staticClass:"font-semibold mt-20 mb-20"},[_vm._v("Emergency")]),_c('a-collapse',{attrs:{"accordion":""}},[_c('a-collapse-panel',{key:"1",attrs:{"header":"Father Contact"}},[_c('emergencydata',{attrs:{"dataemer":[
          {
            name_th:
              _vm.dataContact[0].father_english_first_name +
              ' ' +
              _vm.dataContact[0].father_english_middle_name +
              ' ' +
              _vm.dataContact[0].father_english_last_name,
            name_en:
              _vm.dataContact[0].father_native_first_name +
              ' ' +
              _vm.dataContact[0].father_native_middle_name +
              ' ' +
              _vm.dataContact[0].father_native_last_name,
            tel: _vm.dataContact[0].father_mobile_number,
            mail: _vm.dataContact[0].father_mobile_email,
            address: _vm.dataContact[0].father_address,
            SubDistrict: _vm.dataContact[0].father_sub_district,
            District: _vm.dataContact[0].father_district,
            Province: _vm.dataContact[0].father_address_province,
            Country: _vm.dataContact[0].father_address_country,
            Code: _vm.dataContact[0].father_address_postal_code,
          } ]}})],1),_c('a-collapse-panel',{key:"2",attrs:{"header":"Mother Contact"}},[_c('emergencydata',{attrs:{"dataemer":[
          {
            name_th:
              _vm.dataContact[0].mother_english_first_name +
              ' ' +
              _vm.dataContact[0].mother_english_middle_name +
              ' ' +
              _vm.dataContact[0].mother_english_last_name,
            name_en:
              _vm.dataContact[0].mother_native_first_name +
              ' ' +
              _vm.dataContact[0].mother_native_middle_name +
              ' ' +
              _vm.dataContact[0].mother_native_last_name,
            tel: _vm.dataContact[0].mother_mobile_number,
            mail: _vm.dataContact[0].mother_mobile_email,
            address: _vm.dataContact[0].mother_address,
            SubDistrict: _vm.dataContact[0].mother_sub_district,
            District: _vm.dataContact[0].mother_district,
            Province: _vm.dataContact[0].mother_address_province,
            Country: _vm.dataContact[0].mother_address_country,
            Code: _vm.dataContact[0].mother_address_postal_code,
          } ]}})],1),_c('a-collapse-panel',{key:"3",attrs:{"header":"Guardian Contact"}},[_c('emergencydata',{attrs:{"dataemer":[
          {
            name_th:
              _vm.dataContact[0].guardian_english_first_name +
              ' ' +
              _vm.dataContact[0].guardian_english_middle_name +
              ' ' +
              _vm.dataContact[0].guardian_english_last_name,
            name_en:
              _vm.dataContact[0].guardian_native_first_name +
              ' ' +
              _vm.dataContact[0].guardian_native_middle_name +
              ' ' +
              _vm.dataContact[0].guardian_native_last_name,
            tel: _vm.dataContact[0].guardian_mobile_number,
            mail: _vm.dataContact[0].guardian_mobile_email,
            address: _vm.dataContact[0].guardian_address,
            SubDistrict: _vm.dataContact[0].guardian_sub_district,
            District: _vm.dataContact[0].guardian_district,
            Province: _vm.dataContact[0].guardian_address_province,
            Country: _vm.dataContact[0].guardian_address_country,
            Code: _vm.dataContact[0].guardian_address_postal_code,
          } ]}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }